import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

export interface DeclineDialogProps {
  version?: number
  busy?: boolean
  onCancel: () => void
  onConfirm: (note: string) => void
}

export default function DeclineDialog({
  version,
  busy = false,
  onCancel,
  onConfirm,
}: DeclineDialogProps) {
  const { formatMessage } = useIntl()
  const [note, setNote] = useState('')

  useEffect(() => {
    setNote('')
  }, [version])

  return (
    <Dialog open={version !== undefined} onClose={onCancel} fullWidth={true} maxWidth="sm">
      <DialogTitle>
        {formatMessage({ id: 'avatarStudio.publish.declineTitle' }, { version })}
      </DialogTitle>
      <DialogContent dividers={true}>
        <TextField
          fullWidth={true}
          multiline={true}
          minRows={3}
          autoFocus={true}
          label={formatMessage({ id: 'avatarStudio.publish.declineReason' })}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          inputProps={{ maxLength: 500 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          {formatMessage({ id: 'avatarStudio.editor.cancel' })}
        </Button>
        <Button
          variant="contained"
          color="warning"
          // A reason is the point: declining silently tells the stager nothing.
          disabled={busy || note.trim() === ''}
          onClick={() => onConfirm(note.trim())}
        >
          {formatMessage({ id: 'avatarStudio.publish.decline' })}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
